import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './App.css';

import LogoTop from "./components/LogoTop";
import LogoYellowNight from "./components/LogoYellowNight";
import BloccoVideo from "./components/BloccoVideo";
import BloccoInvito from "./components/BloccoAccettazione";
import BloccoProgramma from "./components/BloccoProgramma";
import BlobboIndicazioni from "./components/BloccoIndicazioni";
import BloccoPreFooter from "./components/BloccoPreFooter";
import BloccoFooter from "./components/BloccoFooter";
function App() {
  const { codice_invito } = useParams();
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!codice_invito) return;

    const fetchCliente = async () => {
      try {
        const res = await fetch(`https://apimoretti.devb01.it/api/customers/${codice_invito}`);
        if (!res.ok) throw new Error('Errore nella fetch');
        const data = await res.json();
        setCliente(data);
      } catch (error) {
        console.error('Errore nel caricamento cliente:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCliente();
  }, [codice_invito]);

  if (loading) return <div className="p-10 text-center text-xl">Caricamento...</div>;
  if (!cliente) return <div className="p-10 text-center text-xl text-red-600">Cliente non trovato.</div>;

  return (
    <div className="grid grid-rows-[auto_1fr_auto] min-h-screen gap-16 p-0 pb-20 sm:p-20 font-[family-name:var(--font-inter)]">
      <div className="row-start-1 w-full flex items-center justify-center">
        <LogoTop />
      </div>

     
        <LogoYellowNight />
     

      <div className="row-start-3 w-full flex items-center justify-center">
        <div className="w-full pt-6 max-w-[1200px]">
          <BloccoVideo />
          <BloccoInvito cliente={cliente} />
          <BloccoProgramma />
          <BlobboIndicazioni />
          <BloccoPreFooter />
          <BloccoFooter />
        </div>
      </div>
    </div>
  );
}

export default App;
